import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
// import { useSession } from '../App'; // Unused - commented out to fix ESLint warning
import MerchantNavigation from './MerchantNavigation';

const MerchantLanding = () => {
    const { merchant } = useParams();
    const navigate = useNavigate();
    // const { logout } = useSession(); // Unused - commented out to fix ESLint warning

    const merchantInfo = {
        madeluxe: {
            name: 'Madeluxe',
            description: 'Fashion and accessories merchant',
            color: 'primary'
        },
        pawesome: {
            name: 'Pawesome',
            description: 'Pet supplies and accessories merchant',
            color: 'success'
        }
    };

    const currentMerchant = merchantInfo[merchant] || {
        name: merchant,
        description: 'Merchant dashboard',
        color: 'secondary'
    };

    const handleNavigateToCategories = () => {
        navigate(`/private/${merchant}/categories`);
    };

    const handleNavigateToOrders = () => {
        navigate(`/private/${merchant}/orders`);
    };

    // const handleNavigateToProducts = () => {
    //     navigate(`/merchant/${merchant}/products`);
    // }; // Unused - commented out to fix ESLint warning

    return (
        <>
            <MerchantNavigation currentPage="dashboard" />

            <Container className="py-5">
                <Row className="mb-4">
                    <Col>
                        <div className="text-center">
                            <h2 className="mb-3">
                                {currentMerchant.name}
                            </h2>
                            <p className="text-muted mb-0">{currentMerchant.description}</p>
                        </div>
                    </Col>
                </Row>



                <Row>
                    <Col>
                        <Card className="shadow-sm">

                            <Card.Body>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Card className="h-100 border-primary">
                                            <Card.Body className="text-center p-4">

                                                <Button
                                                    variant="primary"
                                                    onClick={handleNavigateToCategories}
                                                    className="w-100"
                                                >
                                                    Categories
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Card className="h-100 border-success">
                                            <Card.Body className="text-center p-4">
                                                <Button
                                                    variant="success"
                                                    onClick={handleNavigateToOrders}
                                                    className="w-100"
                                                >
                                                    Manage Orders
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                </Row>
                            </Card.Body>

                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MerchantLanding;
